
      var _path, _path2, _path3, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAndroidIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 99,
  height: 26,
  viewBox: "0 0 99 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.589 19v-.234l3.744-10.35h2.61l3.888 10.35V19h-2.268l-.792-2.268H6.649L5.875 19H3.589Zm3.582-4.05h3.042l-1.566-4.428L7.17 14.95ZM14.983 19v-8.46h2.142v1.242c.864-.81 1.89-1.35 2.863-1.35 1.944 0 2.898 1.296 2.898 3.528V19h-2.142v-4.896c0-1.224-.486-1.854-1.44-1.854-.846 0-1.53.468-2.178 1.26V19h-2.143Zm12.99.144c-2.087 0-3.527-1.584-3.527-4.266 0-2.808 1.458-4.5 3.654-4.5 1.044 0 1.872.432 2.448 1.152V7.66h2.142V19h-2.142v-1.098c-.576.774-1.458 1.242-2.574 1.242Zm-1.493-4.41c0 1.44.612 2.574 1.998 2.574 1.368 0 2.052-1.098 2.088-2.538.018-1.44-.702-2.556-2.088-2.556-1.386 0-1.998 1.116-1.998 2.52ZM34.776 19v-8.46h2.142v1.206c.738-.774 1.782-1.26 2.61-1.26v1.962c-1.044 0-1.998.432-2.61 1.17V19h-2.142Zm9.384.144c-2.717 0-4.157-1.836-4.157-4.374 0-2.538 1.44-4.392 4.157-4.392 2.719 0 4.087 1.854 4.087 4.392 0 2.538-1.368 4.374-4.087 4.374Zm-2.123-4.374c-.018 1.422.684 2.538 2.105 2.538 1.422 0 2.07-1.116 2.07-2.538 0-1.422-.648-2.556-2.07-2.556-1.422 0-2.07 1.134-2.106 2.556ZM49.913 19v-8.46h2.142V19h-2.142Zm-.108-9.558V7.66h2.34v1.782h-2.34Zm7.435 9.702c-2.088 0-3.528-1.584-3.528-4.266 0-2.808 1.458-4.5 3.654-4.5 1.044 0 1.872.432 2.448 1.152V7.66h2.142V19h-2.142v-1.098c-.576.774-1.458 1.242-2.574 1.242Zm-1.494-4.41c0 1.44.612 2.574 1.998 2.574 1.368 0 2.052-1.098 2.088-2.538.018-1.44-.702-2.556-2.088-2.556-1.386 0-1.998 1.116-1.998 2.52Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.25 19v-2.144c0-5.389 4.327-9.837 9.716-9.856a9.75 9.75 0 0 1 9.784 9.75V19a.75.75 0 0 1-.75.75H76a.75.75 0 0 1-.75-.75Z",
  fill: "var(--theme-bright, #e3d2e9)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m76 6.25 2.913 2.913M94 6.25l-2.897 2.897",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 88.375,
  cy: 15.625,
  r: 1.125,
  fill: "var(--theme-primary, #810ea9)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 81.625,
  cy: 15.625,
  r: 1.125,
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"99\" height=\"26\" viewBox=\"0 0 99 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M3.58889 19V18.766L7.33289 8.416H9.94289L13.8309 18.766V19H11.5629L10.7709 16.732H6.64889L5.87489 19H3.58889ZM7.17089 14.95H10.2129L8.64689 10.522L7.17089 14.95ZM14.9835 19V10.54H17.1255V11.782C17.9895 10.972 19.0155 10.432 19.9875 10.432C21.9315 10.432 22.8855 11.728 22.8855 13.96V19H20.7435V14.104C20.7435 12.88 20.2575 12.25 19.3035 12.25C18.4575 12.25 17.7735 12.718 17.1255 13.51V19H14.9835ZM27.9738 19.144C25.8858 19.144 24.4458 17.56 24.4458 14.878C24.4458 12.07 25.9038 10.378 28.0998 10.378C29.1438 10.378 29.9718 10.81 30.5478 11.53V7.66H32.6898V19H30.5478V17.902C29.9718 18.676 29.0898 19.144 27.9738 19.144ZM26.4798 14.734C26.4798 16.174 27.0918 17.308 28.4778 17.308C29.8458 17.308 30.5298 16.21 30.5658 14.77C30.5838 13.33 29.8638 12.214 28.4778 12.214C27.0918 12.214 26.4798 13.33 26.4798 14.734ZM34.7764 19V10.54H36.9184V11.746C37.6564 10.972 38.7004 10.486 39.5284 10.486V12.448C38.4844 12.448 37.5304 12.88 36.9184 13.618V19H34.7764ZM44.1605 19.144C41.4425 19.144 40.0025 17.308 40.0025 14.77C40.0025 12.232 41.4425 10.378 44.1605 10.378C46.8785 10.378 48.2465 12.232 48.2465 14.77C48.2465 17.308 46.8785 19.144 44.1605 19.144ZM42.0365 14.77C42.0185 16.192 42.7205 17.308 44.1425 17.308C45.5645 17.308 46.2125 16.192 46.2125 14.77C46.2125 13.348 45.5645 12.214 44.1425 12.214C42.7205 12.214 42.0725 13.348 42.0365 14.77ZM49.9137 19V10.54H52.0557V19H49.9137ZM49.8057 9.442V7.66H52.1457V9.442H49.8057ZM57.2414 19.144C55.1534 19.144 53.7134 17.56 53.7134 14.878C53.7134 12.07 55.1714 10.378 57.3674 10.378C58.4114 10.378 59.2394 10.81 59.8154 11.53V7.66H61.9574V19H59.8154V17.902C59.2394 18.676 58.3574 19.144 57.2414 19.144ZM55.7474 14.734C55.7474 16.174 56.3594 17.308 57.7454 17.308C59.1134 17.308 59.7974 16.21 59.8334 14.77C59.8514 13.33 59.1314 12.214 57.7454 12.214C56.3594 12.214 55.7474 13.33 55.7474 14.734Z\" fill=\"#000000\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M75.25 19V16.8558C75.25 11.4672 79.5769 7.01871 84.9655 7.00006C87.5573 6.99089 90.0461 8.01407 91.8821 9.84353C93.718 11.673 94.75 14.1582 94.75 16.75V19C94.75 19.4142 94.4142 19.75 94 19.75H76C75.5858 19.75 75.25 19.4142 75.25 19Z\" fill=\"var(--theme-bright, #e3d2e9)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M76 6.25L78.9131 9.16309\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M94 6.25L91.1034 9.14659\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"88.375\" cy=\"15.625\" r=\"1.125\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<circle cx=\"81.625\" cy=\"15.625\" r=\"1.125\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/androidIcon.f4e9c7a27eff39a8a0a6718c93769d7b.svg"),
        {
          React: SvgAndroidIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      